import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
// import { TruncatePipe } from "src/app/pipe/truncate.pipe";
declare var $:any;

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent {

  public dataListing:any=[];
  public loading:boolean = true;
  public loginDetail:any =[];
  public totalCount: number = 0;
  public p = 1;
  public pageLimit:any = 10;
  public previousLabel:any='';
  public nextLabel:any='';
  public searchKey:any='';
  public currentUrl:any=this.router.url;
  public sortType:any='desc';

  constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = JSON.parse(localStorage.getItem('gra_login') || "{}");   
    this.getDetail(this.p);
   }

  ngOnInit(): void {
  }

  getDetail(page:any){  
    this.loading = true;  
    var url='';
    if(this.currentUrl == '/feedback'){
      url='/user-feedbacks?page='+page;    
    }
    else {
      url='/user-reports?page='+page;  
    }  if(this.searchKey !='') {
      url=url+'&search='+this.searchKey;  
    } 
    url=url+'&sortBy=createdAt'+'&sortOrder='+this.sortType;
        this.service.GetApi(url).subscribe(((response:any)=>{  
        if(response.success ==1) {  
          response.data.record.filter((el:any)=>{
            el.typename='';
            el.message='';
            el.postName='';
            if(el.creator.length !=0){
              el.creator=el.creator[0].name +' ' +el.creator[0].surname; 
            } else {
              el.creator=''; 
            }
            el.createdBy=el.users[0].name +' ' +el.users[0].surname;        
            if(el.type ==1){
              el.typename='Single Post';
              if(el.posts.length !=0){
              el.postName=el.posts[0].name;
              } else {
              el.postName=''; 
            }
            }
            if(el.type ==2){
              el.typename='Program';
              if(el.programs.length !=0){
              el.postName=el.programs[0].name;
              } else {
              el.postName=''; 
            }
            }
            if(el.type ==3){
              el.typename='Album';
            if(el.albums.length !=0){
              el.postName=el.albums[0].name;
              } else {
              el.postName=''; 
            }
            }
            if(this.currentUrl == '/feedback'){
              if(el.feedback ==1){
                el.message='Easy';
              }
              if(el.feedback ==2){
                el.message='Loved It';
              }
              if(el.feedback ==3){
                el.message='To Hard';
              }
              if(el.feedback ==4){
                el.message='Finish Later';
              }
            } else {
              if(el.report ==1){
                el.message='Spam';
              }
              if(el.report ==2){
                el.message='In Appropriate';
              }
              if(el.report ==3){
                el.message='Copy Right Issue';
              }
            }
          })
          this.dataListing= response.data.record;  
          this.totalCount = response.data.total; 
          this.loading=false;
        } else {
          this.dataListing=[]; 
          this.totalCount = 0;
          this.loading=false;
        }
      }), (error) => { this.loading =false; });
  }

     reset(){
      this.p=1;
      this.searchKey='';
      this.getDetail(this.p);
    }
  
}
